export default __webpack_public_path__ + "static/media/VIC-DH-logo-black.2a3acd50.jpg";